import React from 'react';
import PropTypes from 'prop-types';
import { TimedProgressSection, sectionShape } from './TimedProgressSection';

const TimedProgress = ({ left, right, width }) => (
  <div className={`c-m-timed-progress${width ? ` c-m-timed-progress--width-${width}` : ''}`}>
    <div className="c-m-timed-progress__content">
      <TimedProgressSection alignment="left" {...left} />
      <TimedProgressSection alignment="right" {...right} />
    </div>
  </div>
);

TimedProgress.propTypes = {
  left: PropTypes.shape(sectionShape).isRequired,
  right: PropTypes.shape(sectionShape).isRequired,
  width: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export { TimedProgress };
